import React, { Component } from "react";
import DatePicker from "react-datepicker";
import "react-datepicker/dist/react-datepicker.css";
import { ko } from "date-fns/esm/locale";
import getYear from "date-fns/getYear";
import getMonth from "date-fns/getMonth";
import getDay from "date-fns/getDay";
import { format } from "date-fns";
import leftarrow from '../../img/icon/left-arrow-icon.png';
import rightarrow from "../../img/icon/right-arrow-icon.png";
/**
* 개발담당:양유빈
* 화면기능:날짜를 입력하기 위한 공통 달력
* -------- props --------
* id="calendar"                      : 여러 datepicker를 이용할 경우 id값을 통한 구분, 할당 하지 않을 경우 기본 값은 _SelectDate_
* setDate={new Date('2022-08-15')}   : 옵션, 기본 설정 날짜 정의
* placeholder="일자를 선택하여 주세요" : 옵션, placeholder 값 할당
* dateFormat="yyyy.MM.dd"            : 옵션, 날짜 포멧 지정
* DateChange={this.handleCalendarChange} :필수값,  Callback이벤트, 부모 컴퍼넌트로 선택된 날짜를 반환 하기 위한 이벤트
ex) 
    <Big3DatePicker
     setDate={new Date('2022-08-15')}
     DateChange={this.handleCalendarChange}
     id="FromDate"
    />
**/

export default class Big3DatePicker extends Component {
    static displayName = Big3DatePicker.name;

    constructor(props) {
        super(props);
        this.state = { setDate: null };
        this.handleChange = this.handleChange.bind(this);
        this.Big3DatePickerRef = React.createRef();
    }
    //초기화
    componentDidMount() {
    }
    //부모 컴포넌트에 선택된 일자 반환
    handleChange(selectDate) {
        this.setState({ setDate: selectDate });
        let tagID = this.props.id === undefined ? "_SelectDate_" : this.props.id;
        
        let retunValue = {
            SelectDate: format(selectDate, "yyyy-MM-dd"),
            returnId: tagID
        }
        this.props.DateChange(retunValue);
    }
     
    render() {
        const dayClassName = (date, SelectedDate) => {
            
            if (getDay(date) === 6) {
                return "dtpicker-saturday";
            }
            else if (getDay(date) === 0) {
                return "dtpicker-sunday ";
            }
            else if (format(date, "yyyy-MM-dd") === format(SelectedDate, "yyyy-MM-dd")) {
                return "dtpicker-selectday";
            }
        } 
        //아이콘 클릭시 달력 오픈
        const inputFocus = () => {
            this.Big3DatePickerRef.current.setOpen(true);
        };
        
        /* id="calendar"                     : 여러 datepicker를 이용할 경우 id값을 통한 구분, 할당 하지 않을 경우 기본 값은 _SelectDate_
        * setDate={new Date('2022-08-15')}   : 기본 설정 날짜 정의
        * placeholder="일자를 선택하여 주세요" :  placeholder 값 할당, 옵션
        * dateFormat="yyyy.MM.dd"            : 날짜 포멧 지정, 옵션
        * DateChange={this.handleCalendarChange} : 필수값, 부모 컴퍼넌트로 선택된 날짜를 반환 하기 위한 이벤트
        */
        let startDate = new Date();
        let setDate = this.props.setDate === undefined ? startDate : this.props.setDate;
        let placeholder = this.props.placeholder === undefined ? "일자를 선택하세요." : this.props.placeholder;
        let dateFormat = this.props.dateFormat === undefined ? "yyyy-MM-dd" : this.props.dateFormat;
        let SelectedDate = this.state.setDate === null ? setDate : this.state.setDate;
        return (
            <div>
                <DatePicker selected={SelectedDate}
                    locale={ko}
                    dateFormat={dateFormat}
                    placeholderText={placeholder}
                    onChange={this.handleChange}
                    className="form-control"
                    showPopperArrow={false}
                    dayClassName={(date) => dayClassName(date, SelectedDate)}
                    ref={this.Big3DatePickerRef}
                    renderCustomHeader={({
                        date,
                        prevMonthButtonDisabled,
                        nextMonthButtonDisabled,
                        decreaseMonth,
                        increaseMonth,
                    }) => (
                        <div className="dtpicker-header">
                            <div
                                className="btn_month btn_month-prev"
                                onClick={decreaseMonth}
                                disabled={prevMonthButtonDisabled}
                            >
                                <img src={leftarrow} className="dtpicker-arrow" alt="Previous" />
                            </div>
                            <div className="dtpicker-month-header">
                                {getYear(date)}.{getMonth(date)+1}
                            </div>

                            <div
                                className="btn_month btn_month-next"
                                onClick={increaseMonth}
                                disabled={nextMonthButtonDisabled}
                            >
                                <img src={rightarrow} className="dtpicker-arrow" alt="Next" />
                            </div>
                        </div>
                    )}
                />
                <div className="calendar_btn pointer" onClick={inputFocus}></div>
            </div>
        );
    }
}

 
